<template>
  <div class="rights-box">
    <img class="banner-box" :src="headerImg"  />
    <div class="content-box">
      <div class="apply-box" v-if="!flag && state === 0">
        <div>您暂不满足领取条件，点击<span class="apply-join" @click="goBank">立即参加</span>；</div>
        <div>{{this.tip1}}</div>
      </div>
      <div class="apply-box-2" v-if="flag">
        <div>{{this.tip2}}</div>
      </div>
      <div v-if="couponList && couponList.length > 0" class="coupon-box">
        <div class="coupon-title">
          <span class="title">优惠券包</span>
          <span>琴岛通和隧e通券包2选1</span>
        </div>
        <div class="coupon-list">
          <div class="coupon-item-box" v-for="child in couponList" :key="child.activityId">
            <template v-if="child.activityCouponsVoList">
              <div class="coupon-item" v-for="item in child.activityCouponsVoList" :key="item.id">
                <div class="top-title">
                  <div>{{item.showTitle}}</div>
                  <span class="subtitle">一次性发放，90天内有效</span>
                </div>
                <div class="coupon-main">
                  <div class="price">¥ {{item.batchMoney}}</div>
                  <div class="num">×  {{item.acLimitNum}} 张</div>
                  <!-- 0-可领取,1-已领取成功,2-不可领取 -->
                  <!-- 0-可领取,1-已领取成功,2-未申请过信用卡或未审核完毕 不可领取，3-不是新用户 不可领取 -->
                  <button class="coupon-btn" v-if="child.state === 0"  @click="handleCoupon(child)">
                    <img src="https://oss.aqdpay.com/appweb/modelCreditCard/getbtn.png" alt="">
                  </button>
                  <button class="coupon-btn" v-if="child.state === 1">
                    <img src="https://oss.aqdpay.com/appweb/modelCreditCard/gethasbtn.png" alt="">
                  </button>
                  <button class="coupon-btn" v-if="child.state === 2 || child.state === 3">
                    <img src="https://oss.aqdpay.com/appweb/modelCreditCard/getnobtn.png" alt="">
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="coupon-tip">说明：以上券包仅可领取一个，领取后不可更换，请慎重选择；领取后可在首页-卡券包-优惠券内查看</div>
      </div>
      <!-- 领劵规则 -->
      <div class="rights-rule">
        <img :src="this.ruleImg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import { listCoupon, getCoupon, applyCardState } from '@/api/modelCreditCard'

export default {
  data () {
    return {
      state: null,
      applyUrl: '',
      idA: '',
      idB: '',
      couponList: [],
      flag: false,
      headerImg: '',
      tip1: '',
      tip2: '',
      ruleImg: ''
    }
  },
  created () {
    this.bankCode = this.$route.query.code
    this.idA = this.$route.query.idA
    this.idB = this.$route.query.idB
    console.log('this.bankCode', this.bankCode)
    if (this.bankCode === 'BQD') {
      this.headerImg = 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/modelCreditCard/bqd/header.png'
      this.tip1 = '如已完成申请，请耐心等待青岛银行审核'
      this.tip2 = '您已持有青岛银行信用卡，暂无法参与本活动；如有其他问题请致电青岛银行4006695568客服电话咨询。'
      this.ruleImg = 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/modelCreditCard/bqd/bqdrsrule.png'
    } else if (this.bankCode === 'CMB') {
      this.headerImg = 'https://oss.aqdpay.com/appweb/modelCreditCard/cmb/header.png'
      this.tip1 = '如已完成申请，请耐心等待招商银行审核'
      this.tip2 = '您已持有招商银行信用卡，暂无法参与本活动；如有其他问题请致电招商银行40082055555客服电话咨询。'
      this.ruleImg = 'https://oss.aqdpay.com/appweb/modelCreditCard/cmb/rightsRule.png'
    } else {
      this.headerImg = 'https://oss.aqdpay.com/appweb/modelCreditCard/banner.png'
      this.tip1 = '如已完成申请，请耐心等待民生银行审核'
      this.tip2 = '您已持有民生银行信用卡，暂无法参与本活动；如有其他问题请致电民生银行4006695568客服电话咨询。'
      this.ruleImg = 'https://oss.aqdpay.com/appweb/modelCreditCard/ms/mscprule.png'
    }
    this.getApply()
    this.getList()
  },
  methods: {
    // 立即申请
    getApply () {
      const requestData = {
        bankCode: this.bankCode
      }
      applyCardState(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          this.state = data.result.state
          this.applyUrl = data.result.applyUrl
        }
      })
    },
    getList () {
      const requestData = {
        bankCode: this.bankCode,
        activityIdList: [this.idA, this.idB]
      }
      listCoupon(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          this.couponList = data.result || []
          if (this.couponList.length > 0) {
            if (this.couponList[0].state === 3) {
              this.flag = true
            }
          }
        }
      })
    },
    handleCoupon (item) {
      if (this.state !== 1) {
        Toast('请点击立即参加, 申请信用卡')
        return
      }
      Dialog.confirm({
        title: '提示',
        message: '您将领取该优惠券包，领取后不可更换，另一券包将自动失效，请确认'
      })
        .then(() => {
          this.getCouponList(item)
        })
        .catch(() => {
          // on cancel
        })
    },
    getCouponList (item) {
      const requestData = {
        bankCode: this.bankCode,
        activityId: item.activityId
      }
      getCoupon(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          Dialog.alert({
            title: '提示',
            message: '领取成功',
            theme: 'round-button'
          })
            .then(() => {
              this.getList()
            })
        }
      })
    },
    goBank () {
      if (this.applyUrl) {
        window.location.href = this.applyUrl
      }
    },
    // 跳转便捷青岛APP
    goApp () {
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.rights-box {
  min-height: 100vh;
  background: #F7D552;
}
.banner-box {
  width: 100%;
}
.content-box {
  position: relative;
  top: -40px;
  background: #fff;
  border-radius: 10px;
  padding: 20px 15px 15px 15px;
  margin: 12px;
}
.apply-box {
  color: #595959;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  line-height: 1.6;
}
.apply-box-2 {
  color: #595959;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.6;
}
.apply-join {
  color: #D75E4D;
}
.coupon-box {
  margin: 20px 0 15px;
}
.coupon-title {
  margin-left: 5px;
  color: #656565;
  font-size: 12px;
  .title {
    margin-right: 8px;
    color: #D75E4D;
    font-size: 16px;
  }
}
.coupon-list {
  margin: 12px 0;
}
.coupon-item-box {
  margin-bottom: 15px;
}
.coupon-item {
  margin-bottom: 15px;
  padding: 8px 12px 3px;
  border-radius: 5px;
  background: #E85A3F;
  color: #fff;
  &:last-child {
    margin-bottom: 0;
  }
}
.top-title {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  font-size: 14px;
  div {
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .subtitle {
    margin-left: 10px;
    padding: 2px 6px;
    border-radius: 20px;
    background: #E14027;
    font-size: 12px;
    white-space: nowrap;
  }
}
.coupon-main {
  display: flex;
  align-items: center;
  font-size: 13px;
  .price {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #E85A3F;
    font-size: 20px;
    font-weight: bold;
    width: 90px;
    height: 40px;
    background: url('https://oss.aqdpay.com/appweb/modelCreditCard/pricebg.png') no-repeat;
    background-size: 100% 100%;
    margin-right: 14px;
  }
  .num {
    flex: 1;
  }
}
.coupon-btn {
  background: transparent;
  width: 60px;
  height: 60px;
  background: #E85A3F;
  img {
    width: 100%;
  }
}
.coupon-tip {
  margin: 0 5px;
  color: #E35D4C;
  font-size: 12px;
}
.rights-rule {
  margin: 30px 0;
  img {
    width: 100%;
  }
}
</style>
